import ResetPasswordRequest from "./ResetPasswordRequest";

export default ResetPasswordRequest;
